import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import TestTube from './Tube.svg';

/**
 * TestTubeImage:
 *  - Render TestTube Image and serve as a wrapper for Image and Dropdown
 */
export function TestTubeImage({label, children}) {
  return (
    <div className='option-content'>
      <Image src={TestTube} alt={label} />
      {children}
    </div>
  );
}

TestTubeImage.propTypes = {
  /**
   * Label for the option to be displayed on top of TestTube
   */
  label: PropTypes.string,
  /**
   * The Dropdown to be displayed on TestTube
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
